export default Object.assign(
  JSON.parse(
    JSON.stringify(require("models/block/blocks/command/blueprints/set.json")),
  ), //make sure all the values are deeply cloned
  {
    category: "alignment",
    groups: ["year 6"],
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "alignment",
            "hard-lock": true,
            editable: false,
          },
        },
        {
          code: {
            type: "string",
            value: "center",
            "hard-lock": true,
            editable: true,
          },
        },
      ],
    },
  },
);
